'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reduxImmutable = require('redux-immutable');

var _accounts = require('./accounts');

var _accounts2 = _interopRequireDefault(_accounts);

var _feiseanna = require('./feiseanna');

var _feiseanna2 = _interopRequireDefault(_feiseanna);

var _events = require('./events');

var _events2 = _interopRequireDefault(_events);

var _stages = require('./stages');

var _stages2 = _interopRequireDefault(_stages);

var _products = require('./products');

var _products2 = _interopRequireDefault(_products);

var _images = require('./images');

var _images2 = _interopRequireDefault(_images);

var _setMusic = require('./setMusic');

var _setMusic2 = _interopRequireDefault(_setMusic);

var _comments = require('./comments');

var _comments2 = _interopRequireDefault(_comments);

var _schools = require('./schools');

var _schools2 = _interopRequireDefault(_schools);

var _scores = require('./scores');

var _scores2 = _interopRequireDefault(_scores);

var _persons = require('./persons');

var _persons2 = _interopRequireDefault(_persons);

var _adjudicators = require('./adjudicators');

var _adjudicators2 = _interopRequireDefault(_adjudicators);

var _announce = require('./announce');

var _announce2 = _interopRequireDefault(_announce);

var _dresschecks = require('./dresschecks');

var _dresschecks2 = _interopRequireDefault(_dresschecks);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = (0, _reduxImmutable.combineReducers)({
  accounts: _accounts2.default,
  feiseanna: _feiseanna2.default,
  events: _events2.default,
  stages: _stages2.default,
  images: _images2.default,
  products: _products2.default,
  setMusic: _setMusic2.default,
  schools: _schools2.default,
  scores: _scores2.default,
  comments: _comments2.default,
  persons: _persons2.default,
  adjudicators: _adjudicators2.default,
  announce: _announce2.default,
  dresschecks: _dresschecks2.default
});


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/index.js
// module id = 704
// module chunks = 0